<svg class="search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8ZM12.0639 14.8924C10.8729 15.5961 9.48362 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 9.48362 15.5961 10.8729 14.8924 12.0639L17.364 14.5355C18.145 15.3166 18.145 16.5829 17.364 17.364C16.5829 18.145 15.3166 18.145 14.5355 17.364L12.0639 14.8924Z" />
</svg>

<style lang="stylus">
  .search-icon
    fill: darken($grey, 10%)
</style>
